// extracted by mini-css-extract-plugin
export default {"container_page":"personal-reading_container_page__0EZeH","text":"personal-reading_text__dUWsR","couple_image":"personal-reading_couple_image__C5EdF"};